export const SHIPMENT_STATUS = {
  PreDelivery: 0,
  Delivering: 1,
  Completed: 2,
} as const

export type ShipmentStatus = (typeof SHIPMENT_STATUS)[keyof typeof SHIPMENT_STATUS]

export const SHIPMENT_STATUS_LABEL: Record<ShipmentStatus, string> = {
  [SHIPMENT_STATUS.PreDelivery]: '配送前',
  [SHIPMENT_STATUS.Delivering]: '配送中',
  [SHIPMENT_STATUS.Completed]: '完了',
} as const
